import Input from "../components/Input";
import Label from "../components/Label";

function ContractSigned() {
    return (
        <div>
            <div className="content mt-5">
                <div className="container">
                    <div className="card p-5">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="">
                                    <div className="">
                                        <div className="row">
                                            <div className="col-lg-5">
                                                <img src="../../dist/img/DoingBusiness 1.png" alt="AdminLTE Logo" className="brand-image" style={{ opacity: '.8', width: 400 }} />
                                            </div>
                                            <div className="col-lg-7">
                                                <div className="row mt-5">
                                                    <div className="col-sm-12 mb-2">
                                                        <h1 className="m-0 form-header">Bedankt voor het ondertekenen van het contract!</h1>
                                                    </div>
                                                    <div className="pr-5">
                                                        <div className="col-sm-12 mb-2">
                                                            Het tekenen van het contract is gelukt en de handtekening wordt gecontroleerd.


                                                        </div>
                                                        <div className="col-sm-12">
                                                            Wij houden u per e-mail op de hoogte over uw aanvraag, dus houd uw mailbox in de gaten.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContractSigned;